export default "__VITE_ASSET__Bfl8a6vS__"